<template>
  <v-dialog
    v-model="active"
    width="500"
  >
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind="{ on }"/>
    </template>

    <v-card>
      <v-tabs
        v-model="tab"
        background-color="primary"
        centered
        dark
        icons-and-text
      >
        <v-tabs-slider></v-tabs-slider>

        <v-tab href="#tab-1" >
          Compartilhar
          <v-icon>mdi-share</v-icon>
        </v-tab>

        <v-tab href="#tab-2" @click="getListShare">
          Lista de compartilhamento
          <v-icon>mdi-account-box</v-icon>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
          key="1"
          value="tab-1"
        >
          <v-card>
            <v-card-title
              class="title grey lighten-4"
              primary-title
            >
              Compartilhar Processamento
            </v-card-title>
            <v-card-text>
              <v-container
                class="fill-height"
              >
                <v-alert
                  dense
                  border="left"
                  type="warning"
                >Ao criar um link compartilhado qualquer pessoa na web com acesso ao link terá acesso ao seu processamento.</v-alert>
                <v-row
                >
                  <!-- <v-col> -->
                    <v-combobox
                      v-model="emailList"
                      label="E-mail"            
                      outlined
                      chips
                      clearable
                      :error-messages="emailListErrors"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          :key="JSON.stringify(data.item)"
                          v-bind="data.attrs"
                          :input-value="data.selected"
                          :disabled="data.disabled"
                          @click:close="data.parent.selectItem(data.item)"
                        >
                          <v-avatar
                            class="accent white--text"
                            left
                            v-text="data.item.slice(0, 1).toUpperCase()"
                          />
                          {{ data.item }}
                        </v-chip>
                      </template>
                    </v-combobox>
                  <!-- </v-col> -->
                </v-row>
                <v-row >
                  <v-select
                    v-model="expiresIn"
                    :items="expireList"
                    label="Expira em"
                    outlined
                    hint="Tempo até a expiração do link"
                  ></v-select>
                </v-row>
                <v-row v-if="urlShared">
                  <v-text-field
                    id="url-field"
                    label="Link para visualizar processamento"
                    v-model="urlShared"
                    hint="Compartilhe este link e o destinatário poderá ter acesso ao processamento"
                    persistent-hint
                    readonly
                    outlined
                  />
                </v-row>
              </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
              <v-btn
                color="accent"
                text
                @click="active = false"
              >
                Fechar
              </v-btn>
              <v-spacer/>
              <v-btn
                color="primary"
                @click="onShareProcessingClick"
                :loading="isSharing"
                v-if="!urlShared"
              >
                Compartilhar
              </v-btn>
              <v-btn
                v-else
                color="accent"
                outlined
                @click="copyToClipboard"          
              >
                Copiar link
              </v-btn>          
            </v-card-actions>
          </v-card>
        </v-tab-item>

        <v-tab-item
          key="2"
          value="tab-2"
        >
          <v-card flat>
            <v-list
              subheader
              two-line
            >
              <v-subheader inset>Compartilhado com</v-subheader>

              <v-list-item
                v-for="share in listShare"
                :key="share.str_share_token"
              >
                <v-list-item-avatar>
                  <v-icon
                    class="grey lighten-1"
                    dark
                  >
                    mdi-share
                  </v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title v-text="share.lst_str_email[0]"></v-list-item-title>

                  <v-list-item-subtitle>Expira em: {{share.dh_expired | formatDate}}</v-list-item-subtitle>
                  <input type="hidden" :id="'url-field-' + share.str_share_token" :value="frontend_url + '/app/processing/share/' + share.str_share_token">                
                </v-list-item-content>
                <v-list-item-action @click="copyUrl(share.str_share_token)">
                  <v-tooltip 
                    bottom                    
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn 
                        icon
                        v-bind="attrs"
                        v-on="on"                                             
                      >
                        <v-icon color="grey lighten-1">mdi-content-copy</v-icon>
                      </v-btn>                      
                    </template>
                    <span>Copiar link</span>
                  </v-tooltip>
                </v-list-item-action> 
                <v-list-item-action @click="deleteShare(share.str_share_token)"> 
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn 
                        icon
                        v-bind="attrs"
                        v-on="on"                       
                      >
                        <v-icon color="grey lighten-1">mdi-delete</v-icon>
                      </v-btn>  
                    </template>
                    <span>Cancelar compartilhamento</span>
                  </v-tooltip>
                </v-list-item-action> 
              </v-list-item>
            </v-list>
          </v-card>
        </v-tab-item>        
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>

<script>
  import {validationMixin} from "vuelidate"
  import {required} from "vuelidate/lib/validators"
  import {generateProcessingShare, getListProcessingsShare, deleteProcessingShare} from "../../api/api-project"
  import {NOTIFICATION_TYPES, NotificationOptions} from "../../helpers/notify"
  import {DIALOG_TYPES, DialogOptions} from "../../helpers/dialogs"
  import {PROCESSING_STATUS} from "../../helpers/processings/constants"
  import {isEqual} from "lodash/lang" 
  import { FRONTEND_URL } from "./../../globals"

  export default {
    name: "ProcessingShareDialog",
    mixins: [validationMixin],
    props: {
      processing: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      tab: null,

      active: false,
      isSharing: false,

      emailList: null,
      expiresIn: 1,

      frontend_url: FRONTEND_URL,

      expireList: [
        {value: 1, text: "1 dia"},
        {value: 7, text: "7 dias"},
        {value: 30, text: "30 dias"}
      ],
      
      urlShared: null,

      listShare: []
    }),
    validations() {
      return {
        emailList: {
          required,
          hasAnyEmailInvalid: () => this.multipleEmailValidation(),
        }
      }
    },
    methods: {
      getListShare() {
        const authToken = this.$apiAuth.getAuthToken()
        let payloadData = {
          cd_processing: this.processing["id_processing"],
        }        
        getListProcessingsShare(authToken, payloadData)
        .then((res) => {
          console.log(">>>> ", res.data.data)
          this.listShare = res.data.data
          window.jbr = this.listShare
        })
        .catch((err) => {
          console.log(err)
        })
      },
      deleteShare(token) {
        const authToken = this.$apiAuth.getAuthToken()
        deleteProcessingShare(authToken, token)
        .then(() => {
          this.getListShare()
          this.$notify(new NotificationOptions({
            message: "Compartilhamento excluído com sucesso.",
            type: NOTIFICATION_TYPES.SUCCESS
          }))            
        })
        .catch((err) => {
          console.log(err)
          this.$notify(new NotificationOptions({
            message: "Não conseguimos excluir o compartilhamento, tente novamente mais tarde.",
            type: NOTIFICATION_TYPES.ERROR
          }))          
        })
      },
      onShareProcessingClick() {
        this.$v.$touch()

        if (this.$v.$invalid) return

        if (!this.processingCanShare) {
          this.$notify(new NotificationOptions({
            message: "Só é possível compartilhar processamentos finalizados",
            type: NOTIFICATION_TYPES.WARNING
          }))
          return
        }

        this.isSharing = true

        let payloadData = {
          lst_str_email: [this.emailList],
          cd_processing: this.processing["id_processing"],
          expire_in: this.expiresIn
        }

        const authToken = this.$apiAuth.getAuthToken()
        generateProcessingShare(authToken, payloadData)
          .then((res) => {
            if (res.data.success == 'admin-processing-share-ok') {
              this.urlShared = res.data.data.url_shared
              this.$dialog(new DialogOptions({
                title: "Compartilhamento de processamento",
                content: "Processamento compartilhado com o email informado.",
                cancelText: "Entendi",
                type: DIALOG_TYPES.ALERT,
              }))              
            } else {
              this.urlShared = res.data.data.url_shared
              this.$dialog(new DialogOptions({
                title: "Compartilhamento de processamento",
                content: "Será enviado um link de compartilhamento do processamento para o email solicitado.",
                cancelText: "Entendi",
                type: DIALOG_TYPES.ALERT,
              }))
            }
          })
          .finally(() => {
            // this.active = false
            this.isSharing = false
          })
      },
      multipleEmailValidation() {
        const emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/

        let isValid = true
        // forEach(this.emailList, email => {
        //   if (!emailRegex.test(email))
        //     isValid = false
        // })
        if (!emailRegex.test(this.emailList))
          isValid = false        
        return isValid
      },
      copyUrl(str_share_token) {
        let url = "#url-field-" + str_share_token
        const fieldToCopy = document.querySelector(url)
        fieldToCopy.setAttribute('type', 'text')
        fieldToCopy.select()
        fieldToCopy.setSelectionRange(0, 999999)
        document.execCommand("copy")
        this.$dialog(new DialogOptions({
          title: "Link copiado",
          content: "O link foi copiado para sua área de transferência.",
          cancelText: "OK",
          type: DIALOG_TYPES.INFO,
        }))
        fieldToCopy.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()        
      },
      copyToClipboard() {
        const fieldToCopy = document.querySelector('#url-field')
        fieldToCopy.select()
        fieldToCopy.setSelectionRange(0, 999999)
        document.execCommand("copy")
        this.$dialog(new DialogOptions({
          title: "Link copiado",
          content: "O link foi copiado para sua área de transferência.",
          cancelText: "OK",
          type: DIALOG_TYPES.INFO,
        })) 
      }      
    },
    mounted(){
      this.urlShared = null
    },
    computed: {
      emailListErrors() {
        const errors = []
        if (!this.$v.emailList.$dirty) return errors
        !this.$v.emailList.required && errors.push("Esse campo é obrigatório")
        !this.$v.emailList.hasAnyEmailInvalid && errors.push("Existe algum email inválido")
        return errors
      },
      processingCanShare() {
        return isEqual(this.processing["ab_processing_status"], PROCESSING_STATUS.ENDED)
      }
    },
  }
</script>

<style scoped>

</style>
